import { useQuery, gql } from "@apollo/client"

const INTEGRATION_PROVIDER_ATTRIBUTE_TYPE_FIELDS = `
  id
  name
  description
  key
`

const INTEGRATION_PROVIDER_FIELDS = `
  id
  name
  link
  shortDescription
  description
  canDisable
  connect {
    authoriseEndpoint
    client
    responseType
    scope
  }
  attributes {
    location { ${INTEGRATION_PROVIDER_ATTRIBUTE_TYPE_FIELDS} }
    locationGroup { ${INTEGRATION_PROVIDER_ATTRIBUTE_TYPE_FIELDS} }
    user { ${INTEGRATION_PROVIDER_ATTRIBUTE_TYPE_FIELDS} }
  }
  operations {
    name
    description
    method
  }
  events
  remoteEvents { remoteName }
`

const INTEGRATION_PROVIDER_QUERY = gql`
  query IntegrationProviders {
    integrationProviders {
      ${INTEGRATION_PROVIDER_FIELDS}
    }
  }
`

const useQueryIntegrationProviders = () => useQuery(INTEGRATION_PROVIDER_QUERY)

export { useQueryIntegrationProviders, INTEGRATION_PROVIDER_FIELDS }
